import ClickAndCollectDisplayOpeningHours from './ClickAndCollectDisplayOpeningHours';

export default ClickAndCollectDisplayOpeningHours;
